import { SolRouteId } from '@sol/components';

export class SolCatalogRouteId {
  // Apps
  public static readonly app_catalog: SolRouteId = '';
  public static readonly app_platform: SolRouteId = 'platform';
  public static readonly app_partner: SolRouteId = 'partner';
  public static readonly app_admin: SolRouteId = 'admin';

  // Documents
  public static readonly documents: SolRouteId = 'documents';
  public static readonly documents_sol_catalog: SolRouteId = 'documents/sol-catalog';
  public static readonly documents_ux_foundation: SolRouteId = 'documents/ux-foundation';

  // Components
  public static readonly components: SolRouteId = 'components';
  public static readonly components_chart: SolRouteId = 'components/chart';
  public static readonly components_chart_line: SolRouteId = 'components/chart/line';
  public static readonly components_core: SolRouteId = 'components/core';
  public static readonly components_core_accordion: SolRouteId = 'components/accordion';
  public static readonly components_core_alert: SolRouteId = 'components/alert';
  public static readonly components_core_avatar: SolRouteId = 'components/avatar';
  public static readonly components_core_badge: SolRouteId = 'components/badge';
  public static readonly components_core_banner: SolRouteId = 'components/banner';
  public static readonly components_core_big_checkbox: SolRouteId = 'components/big-checkbox';
  public static readonly components_core_big_radiobutton: SolRouteId = 'components/big-radiobutton';
  public static readonly components_core_budget: SolRouteId = 'components/budget';
  public static readonly components_core_button: SolRouteId = 'components/button';
  public static readonly components_core_button_group: SolRouteId = 'components/button-group';
  public static readonly components_core_card: SolRouteId = 'components/card';
  public static readonly components_core_checkbox: SolRouteId = 'components/checkbox';
  public static readonly components_core_comment: SolRouteId = 'components/comment';
  public static readonly components_core_date_field: SolRouteId = 'components/date-field';
  public static readonly components_core_diff: SolRouteId = 'components/diff';
  public static readonly components_core_empty_state: SolRouteId = 'components/empty-state';
  public static readonly components_core_file_upload: SolRouteId = 'components/file-upload';
  public static readonly components_core_filter_field: SolRouteId = 'components/filter-field';
  public static readonly components_core_icon: SolRouteId = 'components/icon';
  public static readonly components_core_image: SolRouteId = 'components/image';
  public static readonly components_core_layout: SolRouteId = 'components/layout';
  public static readonly components_core_list: SolRouteId = 'components/list';
  public static readonly components_core_loader: SolRouteId = 'components/loader';
  public static readonly components_core_log: SolRouteId = 'components/log';
  public static readonly components_core_markdown: SolRouteId = 'components/markdown';
  public static readonly components_core_query_field: SolRouteId = 'components/query-field';
  public static readonly components_core_radio_button: SolRouteId = 'components/radio-button';
  public static readonly components_core_relative_date_field: SolRouteId = 'components/relative-date-field';
  public static readonly components_core_scroll_view: SolRouteId = 'components/scroll-view';
  public static readonly components_core_select: SolRouteId = 'components/select';
  public static readonly components_core_severity: SolRouteId = 'components/severity';
  public static readonly components_core_snippet: SolRouteId = 'components/snippet';
  public static readonly components_core_spinner: SolRouteId = 'components/spinner';
  public static readonly components_core_steps: SolRouteId = 'components/steps';
  public static readonly components_core_switch: SolRouteId = 'components/switch';
  public static readonly components_core_table: SolRouteId = 'components/table';
  public static readonly components_core_tag: SolRouteId = 'components/tag';
  public static readonly components_core_tag_color: SolRouteId = 'components/tag-color';
  public static readonly components_core_text_area: SolRouteId = 'components/text-area';
  public static readonly components_core_text_box: SolRouteId = 'components/text-box';
  public static readonly components_core_text_field: SolRouteId = 'components/text-field';
  public static readonly components_core_time_field: SolRouteId = 'components/time-field';
  public static readonly components_core_toggle_chip: SolRouteId = 'components/toggle-chip';
  public static readonly components_core_tooltip: SolRouteId = 'components/tooltip';
  public static readonly components_core_trend: SolRouteId = 'components/trend';
  public static readonly components_core_view_box: SolRouteId = 'components/view-box';
  public static readonly components_overview: SolRouteId = 'components/overview';
  public static readonly components_services: SolRouteId = 'components/services';
  public static readonly components_tools: SolRouteId = 'components/tools';
  public static readonly components_tools_workbench: SolRouteId = 'components/workbench';
  public static readonly components_tools_variant: SolRouteId = 'components/variant';
  public static readonly components_detail: SolRouteId = 'components/detail';
  public static readonly components_form: SolRouteId = 'components/form';
  public static readonly components_navigation: SolRouteId = 'components/navigation';
  public static readonly components_notification: SolRouteId = 'components/notification';
  public static readonly components_popover: SolRouteId = 'components/popover';
  public static readonly components_search: SolRouteId = 'components/search';
  public static readonly components_tab: SolRouteId = 'components/tab';
  public static readonly components_view: SolRouteId = 'components/view';

  // Account
  public static readonly account_section1: SolRouteId = 'account-section1';
  public static readonly account_preferences: SolRouteId = 'preferences';
  public static readonly account_section2: SolRouteId = 'account-section2';
  public static readonly account_logout: SolRouteId = 'logout';
}
